import { IMachine } from 'lib_ts/interfaces/i-machine';
import { useEffect } from 'react';
import { useTrainedMsStore } from 'stores/use-trained-ms-store';

// old shots will be irrelevant when changing machine/ball type/etc...
// not strictly necessary since the key is TMS _id, but good to free up memory
const useRecycleTmsShots = (machine: IMachine) => {
  useEffect(() => {
    useTrainedMsStore.getState().resetShots();
  }, [machine.machineID, machine.ball_type, machine.last_hardware_changed]);
};

export default useRecycleTmsShots;
